import React, { useEffect, useRef } from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active-reveal');
          } else {
            entry.target.classList.remove('active-reveal');
          }
        });
      },
      { threshold: 0.1 }
    );

    // Cards aur Header dono ko select karke observe kar rahe hain
    const items = sectionRef.current.querySelectorAll('.work-step, .work-header-anim');
    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  const steps = [
    { num: "01", icon: "📥", title: "Install & Register", desc: "Download our The Doctor At Home app from Play Store and sign up easily." },
    { num: "02", icon: "👨‍⚕️", title: "Choose Your Doctor", desc: "Select from our verified doctors based on specialty, experience and rating." },
    { num: "03", icon: "📅", title: "Book Appointment", desc: "Pick your preferred date & time. Doctor arrives as scheduled at your home." },
    { num: "04", icon: "💳", title: "Pay Securely", desc: "UPI, Cards, or Wallets – your choice, always secure with multiple payment options." }
  ];

  return (
    <section className="work-section" id='how-it-works' ref={sectionRef}>
      {/* Header with Animation Class */}
      <div className="work-header work-header-anim">
        <span className="step-tag">Step-by-Step Guide</span>
        <h2>How <span>The Doctor At Home</span> Works</h2>
        <div className="animated-bar"></div>
      </div>

      <div className="work-container">
        {steps.map((step, index) => (
          <div key={index} className={`work-step delay-${index}`}>
            <div className="step-card">
              <div className="step-number">{step.num}</div>
              <div className="step-icon-box">{step.icon}</div>
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
              <div className="bottom-glow" style={{background: index % 2 === 0 ? '#0062ff' : '#00d4ff'}}></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;